define([
    'ractive',
    'app/helpers/helpers',
    'nouislider/distribute/nouislider',
    'jQuery-File-Upload/js/jquery.iframe-transport',
    'jQuery-File-Upload/js/jquery.fileupload',
    'jQuery-File-Upload/js/jquery.fileupload-process',
    'jQuery-File-Upload/js/jquery.fileupload-validate',
], function (Ractive, helpers, NoUiSlider) {
    const balloonState = {
        clicks: 0,
        isAnimating: false,
    };

    const fireConfetti = (ratio, options) => {
        if (confetti !== undefined && confetti) {
            const defaultCount = 50;
            const newCount = Math.floor(defaultCount * ratio);
            confetti(
                Object.assign({}, options, {
                    particleCount: newCount,
                    gravity: 2,
                })
            );
        }
    };

    const triggerSuperConfetti = (x, y) => {
        fireConfetti(0.7, {
            spread: 80,
            startVelocity: 70,
            origin: { x: x, y: y },
        });

        fireConfetti(0.6, {
            spread: 100,
            origin: { x: x, y: y },
        });

        fireConfetti(0.9, {
            spread: 200,
            decay: 0.91,
            scalar: 0.8,
            origin: { x: x, y: y },
        });

        fireConfetti(0.3, {
            spread: 240,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.2,
            origin: { x: x, y: y },
        });

        fireConfetti(2, {
            spread: 270,
            startVelocity: 87,
            origin: { x: x, y: y },
        });
    };

    const pkBalloon = document.getElementById('pk-balloon');

    const handleBalloonFlash = () => {
        balloonState.isAnimating = true;
        pkBalloon.style.filter = 'brightness(200%)';

        setTimeout(() => {
            pkBalloon.style.transition = 'filter 0.3s';
            setTimeout(() => {
                pkBalloon.style.filter = 'brightness(100%)';
                setTimeout(() => {
                    pkBalloon.style.transition = '';
                    balloonState.isAnimating = false;
                }, 20);
            }, 20);
        }, 20);
    };

    function scrollTo(c, e, d) {
        d || (d = easeOutCuaic);
        var a = document.documentElement;
        if (0 === a.scrollTop) {
            var b = a.scrollTop;
            ++a.scrollTop;
            a = b + 1 === a.scrollTop-- ? a : document.body;
        }
        b = a.scrollTop;
        0 >= e ||
            ('object' === typeof b && (b = b.offsetTop),
            'object' === typeof c && (c = c.offsetTop),
            (function (a, b, c, f, d, e, h) {
                function g() {
                    0 > f || 1 < f || 0 >= d
                        ? (a.scrollTop = c)
                        : ((a.scrollTop = b - (b - c) * h(f)), (f += d * e), setTimeout(g, e));
                }
                g();
            })(a, b, c, 0, 1 / e, 20, d));
    }
    function easeOutCuaic(t) {
        t--;
        return t * t * t + 1;
    }

    const handleBalloonPop = (x, y) => {
        balloonState.isAnimating = true;
        scrollTo(0, 2000);
        const pkFooter = document.getElementById('pk-footer');

        pkBalloon.classList.remove('floating');

        pkFooter.style.overflow = 'visible';
        const elementDistanceToTop = pkBalloon.getBoundingClientRect().top;
        const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const marginOffset = -3.5 * remInPx;

        pkBalloon.style.position = 'fixed';
        pkBalloon.style.top = `${elementDistanceToTop - marginOffset}px`;

        setTimeout(() => {
            pkBalloon.style.transition = 'top 2.5s ease-out, transform 0.15s ease';
            setTimeout(() => {
                pkBalloon.style.top = '35vh';
                pkBalloon.style.zIndex = '999';
                setTimeout(() => {
                    pkBalloon.style.transform = 'translate3d(-50%, 0, 0) scale(0.4)';
                    setTimeout(() => {
                        balloonState.isAnimating = false;
                        pkFooter.style.overflow = '';
                        pkBalloon.style.transition = '';

                        triggerSuperConfetti(0.5, 0.35);
                        pkBalloon.style.transform = ``;
                        pkBalloon.style.top = ``;
                        pkBalloon.style.zIndex = '';

                        pkBalloon.style.position = 'absolute';

                        setTimeout(() => {
                            pkBalloon.classList.add('floating');
                        }, 20);
                    }, 150);
                }, 2000);
            }, 20);
        }, 20);
    };

    const handleBalloonClick = (event) => {
        if (!balloonState.isAnimating) {
            balloonState.clicks++;

            partyking.common.trigger('footerBalloonClicked', {
                count: balloonState.clicks,
            });

            if (balloonState.clicks < 2) {
                handleBalloonFlash();
            } else {
                const screenWidth = window.innerWidth;
                const screenHeight = window.innerHeight;

                const x = event.x / screenWidth;
                const y = event.y / screenHeight;

                handleBalloonPop(x, y);
                balloonState.clicks = 0;
            }
        }
    };

    pkBalloon.addEventListener('click', handleBalloonClick);
    Ractive.DEBUG = false;

    var ractiveHelpers = Ractive.defaults.data;

    ractiveHelpers.pages = {};

    $.extend(true, ractiveHelpers, partyking.config);
    $.extend(true, ractiveHelpers.pages, partyking.pages);
    $.extend(ractiveHelpers, helpers);

    ractiveHelpers.log = function (val) {
        return 'logged';
    };

    ractiveHelpers.arrCombine = function (var1, var2) {
        return [var1, var2];
    };

    ractiveHelpers.test = function (val) {
        return 'test' + val;
    };

    ractiveHelpers.round = function (val) {
        return Math.round(val);
    };

    ractiveHelpers.capitalize = function (val) {
        return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    };

    ractiveHelpers.stringify = function (val) {
        return JSON.stringify(val);
    };

    ractiveHelpers.objectLength = function (obj) {
        var i = 0;

        $.each(obj, function () {
            i++;
        });

        return i;
    };

    ractiveHelpers.partyking = JSON.parse(JSON.stringify(partyking));

    /* ractive decorators for fileupload */
    var fileupload = function (node, doneMessage, botTest) {
        var url = '/js/libs/jQuery-File-Upload/server/php/';
        var that = $(node);
        var fileContainer = that.closest('#bilaga');

        that.addClass('has-fileupload');
        that.fileupload({
            url: url,
            dataType: 'json',
            dropZone: null,
            start: function (e, data) {
                fileContainer.find('.disable-while-uploading, .disable-at-upload').attr('disabled', true);
                fileContainer.find('.disable-at-upload').parent().addClass('disabled');
                fileContainer.find('.choosen-file .name').text(partyking.common.helpers.l.translate('Laddar upp...'));
            },
            done: function (e, data) {
                var result = data.result.files[0];

                if (result.error) {
                    fileContainer.find('.progress').css('width', '0%');

                    fileContainer.find('.disable-while-uploading, .disable-at-upload').attr('disabled', false);
                    fileContainer.find('.disable-at-upload').parent().removeClass('disabled');
                    fileContainer.find('.choosen-file .name').text('');

                    partyking.common.models.messages.warning('inline', result.error);
                } else {
                    fileContainer.find('.disable-while-uploading').attr('disabled', false);
                    fileContainer
                        .find('.choosen-file .name')
                        .text(partyking.common.helpers.l.translate('Uppladdad:') + ' ' + data.result.files[0].name);
                }

                partyking.common.trigger('fileuploaded', data.result.files[0]);

                if (doneMessage) {
                    partyking.common.models.messages.message('inline', '<div>' + doneMessage + '</div>');
                }
            },
            progressall: function (e, data) {
                var progress = parseInt((data.loaded / data.total) * 100, 10);
                fileContainer.find('.progress').css('width', progress + '%');
            },
        }).on('fileuploadprocessalways', function (e, data) {
            if (botTest) {
                data.abort();
            }
        });

        if (botTest) {
            $(node).fileupload('destroy');
            return {
                teardown: function () {},
            };
        }

        return {
            teardown: function () {
                if ($(node).hasClass('.has-fileupload')) {
                    $(node).fileupload('destroy');
                }
            },
        };
    };

    /* ractive decorators for NoUiSlider */

    ractiveHelpers.handles = {
        left: 0,
        right: 9995,
    };

    var slider = function (node, min, max) {
        var thisRactive = this;
        $(node).addClass('has-slider');

        if (min == max) {
            min = min - 10;
            max = max + 10;

            if (min < 0) {
                max = max + Math.abs(min);
                min = 0;
            }
        }

        ractiveHelpers.handles.left =
            ractiveHelpers.handles.left || ractiveHelpers.handles.left === 0 ? ractiveHelpers.handles.left : min;
        ractiveHelpers.handles.right =
            ractiveHelpers.handles.right || ractiveHelpers.handles.right === 0 ? ractiveHelpers.handles.right : max;
        // Gör om till kronor och avrunda till närmaste hundratal	r
        var minValue = parseInt(min); //Math.floor((min / 100) / 100) * 100
        var maxValue = parseInt(max); //Math.ceil((max / 100) / 100) * 100

        var selectedMinValue = thisRactive.get('prices.minSet');
        var selectedMaxValue = thisRactive.get('prices.maxSet');

        if (
            (ractiveHelpers.handles.left || ractiveHelpers.handles.left === 0) &&
            ractiveHelpers.handles.left < selectedMinValue
        ) {
            selectedMinValue = ractiveHelpers.handles.left;
        }

        if (ractiveHelpers.handles.right && ractiveHelpers.handles.right > selectedMaxValue) {
            selectedMaxValue = ractiveHelpers.handles.right;
        }

        selectedMaxValue = selectedMaxValue > max ? max : selectedMaxValue;
        selectedMinValue = selectedMinValue < min ? min : selectedMinValue;

        var changeDelay = 50;
        var changeInProgress = false;

        //ractiveHelpers.handles.left = selectedMinValue
        //ractiveHelpers.handles.right = selectedMaxValue

        NoUiSlider.create(node, {
            start: [selectedMinValue, selectedMaxValue], // Handle start position
            step: 1, // Slider moves in increments of '10'
            margin: partyking.config.currency.currency == 'EUR' ? 2 : 20, // Handles must be more than 'X' apart
            connect: true, // Display a colored bar between the handles
            orientation: 'horizontal', // Orient the slider vertically
            range: {
                // Slider can select '0' to '100'
                min: minValue,
                max: maxValue,
            },
        });

        // need to have booth min, max and minSet,maxSet to prevent a never ending loop
        // of destroying and creating the decorator

        node.noUiSlider.on('slide', function (values, handle) {
            var minSet = parseInt(values[0]);
            var maxSet = parseInt(values[1]);

            minSet = !isNaN(minSet) ? minSet : 0;
            maxSet = !isNaN(maxSet) ? maxSet : 9995;

            ractiveHelpers.handles.left = minSet;
            ractiveHelpers.handles.right = maxSet;
        });

        node.noUiSlider.on('update', function (values, handle) {
            var minSet = parseInt(values[0]);
            var maxSet = parseInt(values[1]);

            minSet = !isNaN(minSet) ? minSet : 0;
            maxSet = !isNaN(maxSet) ? maxSet : 9995;

            thisRactive.set('prices.minSet', minSet);
            thisRactive.set('prices.maxSet', maxSet);
        });

        node.noUiSlider.on('change', function (values, handle) {
            thisRactive.fire('updatePriceFilter');
        });

        return {
            teardown: function () {
                if ($(node).hasClass('has-slider')) {
                    node.noUiSlider.destroy();
                }
            },
        };
    };

    /* ractive fade transition */
    var fade = function (t, params) {
        var DEFAULTS = {
            delay: 0,
            duration: 300,
            easing: 'linear',
        };

        var targetOpacity;

        params = t.processParams(params, DEFAULTS);

        if (t.isIntro) {
            targetOpacity = t.getStyle('opacity');
            t.setStyle('opacity', 0);
        } else {
            targetOpacity = 0;
        }

        t.animateStyle('opacity', targetOpacity, params).then(function () {
            t.complete();
            /* if(t.isIntro){
																		t.setStyle('opacity', 1);
																	} */
        });
    };

    Ractive.decorators.fileupload = fileupload;
    Ractive.decorators.slider = slider;
    Ractive.defaults.data = ractiveHelpers;
    Ractive.transitions.fade = fade;
    Ractive.components.Input = Ractive.extend({
        template: `<div class="py-3"><div class="relative border border-accent-darker
            rounded-2xl appearance-none label-floating">
            <input type="{{ type }}" name="{{ name }}" id="{{ id }}"
            placeholder=" "
            class="h-12 w-full"
            value="{{ value }}"{{#if required}} required=""{{/if}}
            on-blur="{{#if validate}}validateField{{/if}}">
            <label for="{{ id }}"
            class="absolute truncate block top-0 text-left pin-t pin-l w-full px-3 py-3 leading-normal cursor-text">{{ placeholder }}</label></div></div>`,
    });
    Ractive.components.Textarea = Ractive.extend({
        template: `<div class="py-3"><div class="relative border border-accent-darker box-border
            rounded-2xl appearance-none label-floating">
            <textarea name="{{ name }}" id="{{ id }}"
            placeholder=" " value="{{ value }}"
            class="h-20 w-full">{{ value }}</textarea>
            <label for="{{ id }}"
            class="absolute block top-0 text-left pin-t pin-l w-full px-3 pb-3 pt-2 leading-normal cursor-text">{{ placeholder }}</label></div></div>`,
    });
    Ractive.components.Checkbox = Ractive.extend({
        template: `<label class="flex items-center cursor-pointer" for="{{ forVal }}">
			<div class="bg-white border rounded-xl border-accent-darker w-8 h-8 flex flex-shrink-0 justify-center items-center mr-2">
				<svg class="fill-current hidden w-3 h-3 text-primary pointer-events-none" version="1.1" viewBox="0 0 17 12" xmlns="http://www.w3.org/2000/svg">
					<g fill="none" fill-rule="evenodd">
					<g transform="translate(-9 -11)" fill="#000000" fill-rule="nonzero">
						<path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
					</g>
					</g>
				</svg>
			</div>
			{{ text ? text : "" }}
		</label>`,
    });
    return {
        ractive: Ractive,
    };
});
